import { Markdown } from './Markdown'
import { Modal } from './Modal'

interface Props {
  label: string
  hint?: string | undefined
  /** Longer beginner-friendly explanation. Supports paragraphs (\n\n), bullets
   *  (lines starting with "- "), bold (**text**), and inline code (`x`). */
  help?: string | undefined
  open: boolean
  onClose: () => void
}

export function HelpModal({ label, hint, help, open, onClose }: Props) {
  return (
    <Modal open={open} onClose={onClose} title={label} testId="help-modal" ariaLabel={`Help: ${label}`}>
      {hint && (
        <p style={{ margin: 0, color: 'var(--ink-700)', fontSize: '0.9rem', lineHeight: 1.5 }}>{hint}</p>
      )}

      {help && (
        <div
          style={{
            marginTop: hint ? '1rem' : 0,
            paddingTop: hint ? '1rem' : 0,
            borderTop: hint ? '1px solid var(--border)' : 'none',
            fontSize: '0.9rem',
            lineHeight: 1.6,
            color: 'var(--ink-700)',
          }}
        >
          <Markdown text={help} compact />
        </div>
      )}

      {!help && !hint && (
        <p style={{ margin: 0, color: 'var(--muted)', fontStyle: 'italic' }}>
          No additional help available for this field yet.
        </p>
      )}
    </Modal>
  )
}
